import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Form, Input, Button, Checkbox } from 'antd';
import { PasswordRequirementCheckBoxes } from './password.requirements';
import { login } from '../../services/api/auth';
import { showSnackbar } from '../snackbar';
import { isLoggedIn } from '../../helpers/auth.helper';
import { getCurrentFacilityURL } from '../../helpers/helper.functions';
import { translateThis } from '../../helpers/language.helper';



const LoginForm = () => {


    const navigate = useNavigate();
    const currentFacilityURL = getCurrentFacilityURL();
    const location = useLocation();
    const isAuth = isLoggedIn();
    // const { from } = location.state || { from: { pathname: `/${currentFacilityURL}/my-portal` } };

    // if (isAuth) {
    //     navigate(from, { replace: true });
    // }



    const [password, setPassword] = useState('');
    const [validPassword, setValidPassword] = useState({
        eightCharacter: false,
        containNumber: false,
        containUpperCase: false,
        containSpecialChar: false
    });

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value); // Update the password value in state
        validatePassword(value); // Call validation on each change
    };


    /**
* To validate password requirement
* @param {String} password 
*/
    const validatePassword = (password) => {
        const rules = {
            eightCharacter: false,
            containNumber: false,
            containUpperCase: false,
            containSpecialChar: false
        }

        if (password.length > 7) { // To check if password contain 8 chars
            rules.eightCharacter = true;
        }
        if (/\d/.test(password)) { // To check if password contain numbers
            rules.containNumber = true;
        }
        if (password !== password.toLowerCase()) { // To check if password contain uppercase
            rules.containUpperCase = true;
        }
        const format = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
        if (format.test(password)) { // To check if password contain special chars
            rules.containSpecialChar = true;
        }
        setValidPassword(rules)
        if (rules.containNumber &&
            rules.containSpecialChar &&
            rules.containUpperCase &&
            rules.eightCharacter
        ) {
            setPassword(password)
        } else {
            setPassword('')
        }
    }

    const onFinish = (formData) => {
        login(formData).then((data) => {
            if (data?.success) {
                showSnackbar().success(data?.message || 'Logged in successfully');
                setTimeout(() => {
                    window.location.href = `/${currentFacilityURL}/my-portal`;
                }, 1000);                
            } else {
                showSnackbar().failure(data?.message || 'Invalid login please try again');
            }

        })
        console.log('Success:', formData);
    };

    const onFinishFailed = (errorState) => {
        if (!errorState.success) {
            showSnackbar().failure('Login failed. Please try again later')
        }

    };

    return (
        <div className='login-form standard-form'>
            <Form
                name="login"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                layout="vertical"
                style={{ maxWidth: '375px', margin: '0 auto' }}
            >
                <Form.Item
                    label={translateThis("Email")}
                    name="email"
                    rules={[{ required: true, message: `${translateThis('Please input your email!')}` }]}
                    style={{ marginBottom: '26px' }}
                >
                    <Input placeholder={translateThis("Email")} />
                </Form.Item>

                <Form.Item
                    className='password-input'
                    label={translateThis("Password")}
                    name="password"
                    rules={[{ required: true, message: `${translateThis('Please input your password!')}` }]}
                >
                    <Input.Password
                        // onChange={(_, value) => validatePassword(value)}

                        // value={password}
                        onChange={(e) => handlePasswordChange(e)}
                        // getValue={(_, value) => validatePassword(value)}
                        placeholder={translateThis("Password")} />
                </Form.Item>
                <Form.Item>
                    <PasswordRequirementCheckBoxes rules={validPassword} />
                </Form.Item>

                <Form.Item name="isRememberMe" valuePropName="checked">
                    <Checkbox className="custom-checkbox">{translateThis("Remember me")}</Checkbox>
                </Form.Item>

                <Form.Item>
                    <Button className='auth-btn' disabled={!password} type="primary" htmlType="submit" block>
                       {translateThis("Log in")}
                    </Button>
                </Form.Item>
            </Form>
            <div style={{ textAlign: 'left',maxWidth: '375px',margin: '0 auto', marginTop: '16px', fontSize: '13px' }}>
                <span style={{ color: 'rgba(255,255,255,0.6)' }}>{translateThis("Don't have an account yet?")} </span>
                <a href="/register">{translateThis('Sign up')}</a>
            </div>
        </div>
    );
};

export default LoginForm;
